import { render, staticRenderFns } from "./WidgetSuntableLayout.vue?vue&type=template&id=54be154c&scoped=true&"
import script from "./WidgetSuntableLayout.vue?vue&type=script&lang=js&"
export * from "./WidgetSuntableLayout.vue?vue&type=script&lang=js&"
import style0 from "./WidgetSuntableLayout.vue?vue&type=style&index=0&id=54be154c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54be154c",
  null
  
)

export default component.exports